export default __webpack_public_path__ + "images/83fd1096bfe8033767d595e3c5ede0fb.png";